import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { GetActualRegistrationFormsForAssociationResponseDto } from '@src/api';
import { BaseResizableComponent } from '@src/app/modules/base';
import { UserService } from '@src/core/services';
import { fixRouteParam } from '@src/utils';

@Component({
  selector: 'app-moderation-users',
  templateUrl: './moderation-users.component.html',
  styleUrls: ['./moderation-users.component.scss', '../styles/administration-content.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModerationUsersComponent extends BaseResizableComponent {
  private readonly userService = inject(UserService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);

  moderationUsers$: BehaviorSubject<GetActualRegistrationFormsForAssociationResponseDto[] | null> =
    this.userService.moderationUsers$;
  selectedUserId?: string;

  get showFullPage(): boolean {
    return !this.selectedUserId;
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.getData();

    this.activatedRoute.paramMap.pipe(takeUntil(this.destroyed$$)).subscribe(params => {
      this.selectedUserId = fixRouteParam(params.get('moderationUserId'));
    });
  }

  onChangeSelectedUserId(selectedUserId?: string) {
    this.selectedUserId = selectedUserId;

    const routerNavigate = ['settings/administration/moderation-users'];
    if (selectedUserId) {
      routerNavigate.push(selectedUserId);
    }
    this.router.navigate(routerNavigate);
  }

  onClickReturnButton() {
    this.onChangeSelectedUserId(undefined);
  }

  reload() {
    this.onClickReturnButton();
    this.getData();
  }

  private getData(): void {
    this.userService.resetModerationUsers();
    this.userService.getModerationUsers();
    this.cdr.markForCheck();
  }
}
